<template>
    <div class="app_wrapper">
      <nav-header ref="navHeader"/>
      <el-scrollbar class="app_main" ref="appMain">
        <transition name="fade-transform" mode="out-in">
            <keep-alive :include="cachedViews">
                <router-view :key="key" />
            </keep-alive>
        </transition>
        <app-footer/>
        <ys-aside-right v-if="$route.path!='/about'"></ys-aside-right>
      </el-scrollbar>
    </div>
</template>
<script>
// import NavHeader from './components/header.vue'
import NavHeader from '@/layout/components/NavHeader.vue'
import appFooter from '@/components/ys-footer'
import ysAsideRight from '@/components/ys-aside-right.vue'
export default{
    name : 'flayout',
    components:{NavHeader,appFooter,ysAsideRight},
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      }
    },
    mounted(){
      //下拉加载
      this.$refs.appMain.wrap.addEventListener("scroll", (e)=>{
        this.$refs.navHeader.onSetHeight(e.target.scrollTop);
      },true)
    }
}
</script>
<style lang="scss" scoped>
  .app {
    &_wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 1060px;
    }
    &_main {
      flex: 1 0 0;

      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      // /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        width: 6px;
        border-radius: 12px;
        background: rgba(0, 0, 0, 0.2);
      }

      ::v-deep {
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .el-scrollbar__bar.is-vertical {
          width: 12px;
        }

        .el-scrollbar__thumb {
          background-color: rgba(144, 147, 153, .6);
        }
      }
    }
  }
</style>